import MobileNav from './components/MobileNav';

/**
 * Controller class.
 *
 * Standardizes how we hook into event listeners and create components.
 */
class Controller {
	constructor() {
		this.init();

		window.addEventListener('resize', this.resized, { passive: true });
		window.addEventListener('load', this.loaded, { passive: true });
	}

	init() {
		MobileNav.init();

		MicroModal.init({
			onShow: (modal: HTMLElement) => {
				document.documentElement.classList.add('modal-open');
				document.body.classList.add('modal-open');
				if (modal.dataset.playerid) {
					window.players[modal.dataset.playerid].play();
				}
			},
			onClose: (modal: HTMLElement) => {
				document.documentElement.classList.remove('modal-open');
				document.body.classList.remove('modal-open');
				if (modal.dataset.playerid) {
					window.players[modal.dataset.playerid].pause();
				}
			},
		});
	}

	// eslint-disable-next-line @typescript-eslint/no-empty-function, prettier/prettier
	resized() {
		MobileNav.vhMobileHeight();
	}

	// eslint-disable-next-line @typescript-eslint/no-empty-function, prettier/prettier
	loaded() { }
}

// Run controller.
new Controller();
